import { RadioGroup, RadioGroupField } from '@/components/ui/radio-group';
import { useClientTranslation } from '@/lib/core/i18n';
import type { TranslationKey } from '@/lib/core/i18n/types';
import { ProductSortKey } from '@/services/platform/api/model';

const SORT_OPTIONS: { value: ProductSortKey; labelKey: TranslationKey }[] = [
  { value: ProductSortKey.Newest, labelKey: 'App.Shop.Filter.SortNewest' },
  { value: ProductSortKey.Oldest, labelKey: 'App.Shop.Filter.SortOldest' },
  { value: ProductSortKey.PriceAsc, labelKey: 'App.Shop.Filter.SortPriceAsc' },
  { value: ProductSortKey.PriceDesc, labelKey: 'App.Shop.Filter.SortPriceDesc' },
  { value: ProductSortKey.TitleAsc, labelKey: 'App.Shop.Filter.SortTitleAsc' },
  { value: ProductSortKey.TitleDesc, labelKey: 'App.Shop.Filter.SortTitleDesc' },
];

export interface FilterSortByProps {
  value?: ProductSortKey;
  onChange: (value: ProductSortKey) => void;
}

export function FilterSortBy({ value, onChange }: FilterSortByProps) {
  const t = useClientTranslation();

  return (
    <RadioGroup
      value={value}
      onValueChange={next => onChange(next as ProductSortKey)}
      className="gap-4 pt-2 pb-7"
    >
      {SORT_OPTIONS.map(option => (
        <RadioGroupField
          key={option.value}
          id={`filter-sort-${option.value}`}
          value={option.value}
          label={t(option.labelKey)}
        />
      ))}
    </RadioGroup>
  );
}
